import { render } from "./introduce.vue?vue&type=template&id=4be6be8c&scoped=true"
import script from "./introduce.vue?vue&type=script&lang=js"
export * from "./introduce.vue?vue&type=script&lang=js"

import "./introduce.vue?vue&type=style&index=0&id=4be6be8c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4be6be8c"

export default script